import { Vector2 } from '../../../odie';

import { CollideEvent, CollideId } from '../../defs/collide';
import {
  despawnBlockEntity,
  KappaBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { BreakEffect } from '../effects/BreakEffect';
import { InvalidEffect } from '../effects/InvalidEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
    kappa block collision resolver
*/
export class KappaCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: KappaBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    block: this._resolveBlock,
    attack: this._resolveAttack,
  };

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, entity: KappaBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  // impl
  //-------------------------------------------------------------------------
  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap() {
    // invalid effect
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveBlock() {
    const component = this._entity.c.blockKappa;
    const position = this._entity.c.position.mapPosition;

    if (component.state === 'soft') {
      this._breakBlock(position);
    }

    return false;
  }

  private async _resolveAttack() {
    this._attack();
    return true;
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _attack() {
    const component = this._entity.c.blockKappa;
    const position = this._entity.c.position.mapPosition;

    // TODO play sound?
    if (component.state === 'soft') {
      this._breakBlock(position);
    } else {
      component.state = 'soft';
    }
  }

  private async _breakBlock(position: Vector2) {
    // despawn entity
    despawnBlockEntity(this._scene, this._entity);

    // execute break effect
    await new BreakEffect(this._scene, {
      position,
      size: this._entity.c.block.props,
      color: 0xffcc44,
    }).execute();
  }
}
